import React from 'react';
import { CountryData, PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { AuthPhoneValue } from 'types/auth';
import { parseAuthPhone } from 'utils/phone';

interface AuthPhoneInputProps {
    value: string;
    defaultCountry: string;
    countries: CountryData[];
    onChange: (phone: string, fields: AuthPhoneValue) => void;
    onBlur?: () => void;
    invalid?: boolean;
}

const AuthPhoneInput: React.FC<AuthPhoneInputProps> = ({
    value,
    defaultCountry,
    countries,
    onChange,
    onBlur,
    invalid,
}) => {
    return (
        <div className={`auth-phone-input${invalid ? ' is-invalid' : ''}`}>
            <PhoneInput
                defaultCountry={defaultCountry}
                countries={countries}
                preferredCountries={[defaultCountry]}
                value={value}
                disableDialCodeAndPrefix
                showDisabledDialCodeAndPrefix
                disableCountryGuess
                placeholder="Your Mobile Number"
                onChange={(phone, { country }) => {
                    onChange(phone, parseAuthPhone(phone, country.iso2, country.dialCode));
                }}
                inputProps={{
                    autoComplete: 'off',
                    name: 'mobile',
                    onBlur,
                }}
                countrySelectorStyleProps={{
                    dropdownStyleProps: {
                        style: { zIndex: 20 },
                    },
                }}
            />
        </div>
    );
};

export default AuthPhoneInput;
